@if(loading) {
  <div class="d-flex justify-content-center align-items-center" [class]="customClass">
    <i class="fad fa-spinner-third fa-spin"></i>
  </div>
}
